import { render, staticRenderFns } from "./UrgentApply.vue?vue&type=template&id=18d7b834&scoped=true&"
import script from "./UrgentApply.vue?vue&type=script&lang=js&"
export * from "./UrgentApply.vue?vue&type=script&lang=js&"
import style0 from "./UrgentApply.vue?vue&type=style&index=0&id=18d7b834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7b834",
  null
  
)

export default component.exports